module.exports = __webpack_public_path__ + "img/puzzle_8.a327df2f.png";